import GradingExperiments from 'bundles/epic/clients/Grading';
import type { SgaAiAssistedKeyVersionEpicValue } from 'bundles/grading-common/types/EpicTypes';

/**
 * Check if Grader Performance Dashboard epic is enabled.
 * @returns boolean
 */
export const graderPerformanceDashboardEnabled = (): boolean => {
  return GradingExperiments.get('enableGraderPerformanceDashboard');
};

/**
 * Check if Grader Overview's FullStory is enabled
 * @returns boolean
 */
export const fullStoryGraderOverviewEnabled = (): boolean => {
  return GradingExperiments.get('enableFullStoryGraderOverview');
};

/**
 * Check if Quick Grader's FullStory is enabled
 * @returns boolean
 */
export const fullStoryQuickGraderEnabled = (): boolean => {
  return GradingExperiments.get('enableFullStorySGA');
};

/**
 * Check if "includePrePenaltyGradesInUI is enabled"
 * @returns boolean
 */
export const getEnablePrePenaltyGrades = (courseId: string) => {
  // eslint-disable-next-line camelcase
  return GradingExperiments.get('includePrePenaltyGradesInUI', { course_id: courseId });
};

/**
 * Get the epic values for the SGA AI Suggestions feature for the OpenAI version
 * @returns SgaAiAssistedKeyVersionEpicValue
 */
export const getSgaOpenAIProdKeyVersion = (): SgaAiAssistedKeyVersionEpicValue => {
  return GradingExperiments.get('sgaOpenAIProdKeyVersion');
};

/**
 * Get the epic values for the SGA AI Suggestions feature for the test courses
 * @returns SgaAiAssistedKeyVersionEpicValue
 */
export const getSgaOpenAITestKeyVersion = (): SgaAiAssistedKeyVersionEpicValue => {
  return GradingExperiments.get('sgaOpenAITestKeyVersion');
};

/**
 * Check if SGA Legacy Deprecation is enabled
 * @returns boolean
 */
export const deprecateLegacySgaGraderEnabled = (): boolean => {
  return GradingExperiments.get('deprecateLegacySgaGrader');
};

/**
 * Check if "feedback" is enabled on "options" rubric
 * https://tools.coursera.org/epic/experiment/hndpV0QjEe2cfhLj_B41Zw
 * @returns boolean
 */
export const isFeedbackOnOptionsEnabled = (): boolean => {
  return GradingExperiments.get('enableFeedbackOnOptionsRubric');
};

/**
 * Check if Assignment Grading is enabled in Public Session
 * https://tools.coursera.org/epic/experiment/Mh19-odYEe-sSw6Cm8RyAw
 * @returns boolean
 */
export const isAssignmentGradingInPublicEnabled = (): boolean => {
  return GradingExperiments.get('enableAssignmentGradingInPublic');
};

/**
 * Check if AI Rubrics Generation should be displayed
 * https://tools.coursera.org/epic/experiment/33oqva0CEe-AWA5y7eOzQQ
 * @returns boolean
 */
export const isAiRubricGenerationEnabled = (): boolean => {
  return GradingExperiments.get('displayAIRubricsGeneration');
};
